import { render, staticRenderFns } from "./CreateMixCampaign.vue?vue&type=template&id=6f385353&scoped=true&"
import script from "./CreateMixCampaign.vue?vue&type=script&lang=js&"
export * from "./CreateMixCampaign.vue?vue&type=script&lang=js&"
import style0 from "./CreateMixCampaign.vue?vue&type=style&index=0&id=6f385353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f385353",
  null
  
)

export default component.exports